import { render, staticRenderFns } from "./listSupplement.vue?vue&type=template&id=b6a656f4&scoped=true&"
import script from "./listSupplement.vue?vue&type=script&lang=js&"
export * from "./listSupplement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6a656f4",
  null
  
)

export default component.exports